var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomFieldEmail = function SvgCustomFieldEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.6515C2.5 6.144 2.74417 6.60484 3.15167 6.88067L8.13583 10.2582C9.265 11.0232 10.7467 11.0232 11.8758 10.2582L16.8475 6.88817C17.2558 6.61317 17.5 6.15234 17.5 5.65984V5.6515C17.5 4.8315 16.835 4.1665 16.015 4.1665H3.985C3.165 4.1665 2.5 4.8315 2.5 5.6515V5.6515Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83301V14.1663C2.5 15.0872 3.24583 15.833 4.16667 15.833H15.8333C16.7542 15.833 17.5 15.0872 17.5 14.1663V5.83301",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98828 15.3447L8.10495 10.228",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9009 10.2339L17.0092 15.3422",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgCustomFieldEmail as ReactComponent };
export default __webpack_public_path__ + "custom-field-email.svg";